import React from 'react';
import { CircleDollarSignIcon } from 'lucide-react';
import { FormData } from '../types';
import { fieldCatalog } from '../utils/config';
import { formatValue, initials } from '../utils/format';
interface LoanHeaderProps {
  values: FormData;
  /** Field ids surfaced as summary metrics, configured by an admin */
  metricIds: string[];
}
export function LoanHeader({
  values,
  metricIds
}: LoanHeaderProps) {
  const borrower = String(values.loanName || 'Loan');
  const loanNumber = String(values.rcmLoanNumber || '');
  const stage = String(values.workflowStatus || '');
  const metrics = metricIds.map(id => fieldCatalog[id]).filter(Boolean).slice(0, 4).map(field => ({
    id: field.id,
    label: field.label,
    value: formatValue(field.type, values[field.id])
  }));
  return <header className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-167" data-mp="b6gmtw2mona3">
      <div className="bg-slate-900 px-6 py-5" data-id="element-168" data-mp="f5fqldcmidzy">
        <div className="flex flex-wrap items-center gap-4" data-id="element-169" data-mp="1w78zjawtcsk4">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 text-base font-bold text-white" data-id="element-170" data-mp="1w5o3thyrj3ko">
            {initials(borrower.replace(',', ''))}
          </span>
          <div className="min-w-0 flex-1" data-id="element-171" data-mp="25vqxzlhmenkl">
            <div className="flex items-center gap-2" data-id="element-172" data-mp="20xz3qkti6pd8">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-blue-300" data-id="element-173" data-mp="20zab0um5qf93">
                Loan Record
              </p>
              <span className="rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-medium text-slate-200" data-id="element-174" data-mp="189be6d1q1dtv">
                {String(values.loanRecordType || 'Refinance')}
              </span>
            </div>
            <h1 className="truncate text-xl font-bold text-white" data-id="element-175" data-mp="1i7r6ukgecv5h">{borrower}</h1>
          </div>
          <div className="flex flex-col items-end gap-1" data-id="element-176" data-mp="2ylps3vao9aw4">
            {stage && <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/15 px-3 py-1 text-sm font-semibold text-emerald-300" data-id="element-177" data-mp="2ynkdtbtrp719">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" data-id="element-178" data-mp="30ot4sj2dhm5l" />
                {stage}
              </span>}
            {loanNumber && <span className="font-mono text-xs text-slate-400" data-id="element-179" data-mp="35qqtvtxgfb6g">#{loanNumber}</span>}
          </div>
        </div>
      </div>

      {metrics.length > 0 && <div className={`grid grid-cols-2 divide-slate-100 md:divide-x ${metrics.length >= 4 ? 'md:grid-cols-4' : metrics.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-180" data-mp="3flsjeqvn6f9k">
          {metrics.map(m => <div key={m.id} className="flex items-center gap-3 border-t border-slate-100 px-5 py-4 md:border-t-0" data-id="element-181" data-mp="2rvya2jaj78u2">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50" data-id="element-182" data-mp="1z9dipiu22wqi">
                <CircleDollarSignIcon className="h-4 w-4 text-blue-600" data-id="element-183" data-mp="24758a678a6rj" />
              </span>
              <div className="min-w-0" data-id="element-184" data-mp="ldc4h4zmmx4h">
                <p className="truncate text-[11px] font-medium uppercase tracking-wide text-slate-400" data-id="element-185" data-mp="lcak29wq0ya3">
                  {m.label}
                </p>
                <p className="truncate text-base font-bold tabular-nums text-slate-900" data-id="element-186" data-mp="cbme82hhe48a">
                  {m.value || '—'}
                </p>
              </div>
            </div>)}
        </div>}
    </header>;
}